let sharedWorker = null;
export const getWorkerConnection = () => {
    if (!sharedWorker) {
        sharedWorker = new SharedWorker(new URL('./shared.worker.ts', import.meta.url), {
            name: 'dixa-shared-worker',
            type: 'module',
        });
    }
    return sharedWorker;
};
